import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import LinkList from '../../../molecules/link-list';
import MailmodoNewsLetter from '../../../molecules/newsletter/mailmodo-news-letter';
import Icon from '@mdi/react';
import { mdiChevronRight } from '@mdi/js';
import { BQLink } from '../../../atoms/bqlink';
import { STRINGS } from '../../../../constants';
import { getInTouchInteraction } from '../../../../helpers/datalayer-utils';

import './sitemap.m.css';

const SiteMap = ({ pageType, userData, siteMapList }) => {
  const footerContact = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'ndtv-footer', 'links', 'getSupport'], null),
  );
  return (
    <div styleName="sitemap-wrapper">
      <LinkList
        links={siteMapList?.quickLinks?.links}
        sectionHeading={siteMapList?.quickLinks?.header}
        accordion={false}
        customClass="vertical-gap-four"
      />
      <LinkList
        links={siteMapList?.allSectionList?.links}
        sectionHeading={siteMapList?.allSectionList?.header}
        accordion={true}
        threeCol={true}
      />
      <LinkList
        links={siteMapList?.stayUpdateLinks?.links}
        sectionHeading={siteMapList?.stayUpdateLinks?.header}
        accordion={false}
        isRegUpdates={true}
        customClass="vertical-gap-two"
      />
      <div styleName="newsletter-and-support">
        <MailmodoNewsLetter page="footer" section="footer" />
        <div
          styleName="get-support-ctx"
          onClick={() => getInTouchInteraction(footerContact.title, userData, pageType)}
        >
          <BQLink href={footerContact?.link} styleName="support-links">
            <div styleName="text-section">
              <img src={footerContact?.path} alt="television" height="40px" width="40px" />
              <div styleName="text-ctx">
                <div styleName="headline">
                  Get&nbsp;<span styleName="bold-support">Support</span>
                  <Icon path={mdiChevronRight} size="32px" color="var(--mine-shaft)" />
                </div>
                <div styleName="sub-headline">{STRINGS.GET_SUPPORT_TEXT}</div>
              </div>
            </div>
            <div className="mobile-only" styleName="right-icon">
              <Icon path={mdiChevronRight} size="30px" color="#B8BFC3" />
            </div>
          </BQLink>
        </div>
      </div>
    </div>
  );
};
export default SiteMap;
